// Typy katalogu dokumentów podlegających akceptacji (zakładka „Dokumenty
// podlegające akceptacji" oraz wybór dokumentu w kreatorze workflow).
//
// Trwałość przeniesiona do BE (per użytkownik + aktywny profil) — patrz
// workflowService.useGetDocuments / useSyncDocuments. Wcześniej lista była
// trzymana wyłącznie w localStorage (klucz workflow_documents_v1) i nie trafiała
// do bazy.

export type DocSource = "form" | "editor";

/**
 * Formularze aplikacji z katalogu („Z formularza") → klucz systemowy typu dokumentu,
 * po którym silnik workflow (BE) dobiera szablon. Szablon zapisujemy z kluczem
 * (np. "engagement"), a w UI pokazujemy nazwę dokumentu.
 */
export const APP_FORM_TYPE_KEYS: Record<string, string> = {
  Zaangażowanie: "engagement",
  "Faktura zakupowa": "invoice_purchase",
  "Faktura sprzedaży": "invoice_sale",
  Rachunek: "bill",
  Umowa: "contract",
};

/** Typy dokumentów, które silnik workflow wykonuje automatycznie (reszta to sama definicja). */
export const ENGINE_SUPPORTED_TYPES = new Set(["engagement"]);

/** Klucz systemowy dla nazwy dokumentu z katalogu (albo sama nazwa, gdy to dokument własny). */
export const systemTypeForDocName = (name: string): string =>
  APP_FORM_TYPE_KEYS[name] ?? name;

/** Nazwa dokumentu z katalogu dla klucza systemowego (odwrotność systemTypeForDocName). */
export const docNameForSystemType = (type: string): string =>
  Object.entries(APP_FORM_TYPE_KEYS).find(([, k]) => k === type)?.[0] ?? type;

export const isEngineSupported = (documentType: string): boolean =>
  ENGINE_SUPPORTED_TYPES.has(systemTypeForDocName(documentType));

export interface CatalogDoc {
  id: string;
  name: string;
  description?: string;
  source: DocSource;
  /** Typ formularza (definiowalny, np. „Kadrowy") — dla źródła „form". */
  formType?: string;
  /** Format pliku — dla źródła „editor". */
  fileFormat?: string;
  /** Tytuł powiązanego workflow (relacja 1:1) — pusty, gdy brak powiązania. */
  workflowTitle?: string;
  isActive: boolean;
  createdAt: string;
}
